<template>
  <div class="payment-methods tes-card pa-7">
    <h1 class="tes-card__title">Способы оплаты</h1>

    <v-row class="mx-1">
      <v-col
        cols="12"
        sm="6"
        class="payment-methods__item"
        v-for="method in methods"
        :key="method.title">
        <payment-method :class="method.class"
                        v-bind="{img: method.logo, color: method.color, title: method.resource, link: method.link}">
        </payment-method>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import PaymentMethod from '@/components/payments/methods/PaymentMethod'
  import {mapState} from 'vuex'

  export default {
    components: {PaymentMethod},
    layout: 'main',
    computed: {
      ...mapState('payments', ['methods'])
    },
    mounted() {
      this.$store.dispatch('payments/getPaymentMethod')
    }
  }
</script>

<style lang="scss">
  .payment-methods {
    &__item {
      width: 380px;
      display: block;
      padding: 20px 0;
    }

    .sberbank img {
      margin-top: 2px;
    }
  }
</style>
